import { __extends } from "tslib";
import { Component, isValidElement } from 'react';
import { getGlobalObject } from '../utils/getGlobalObject';
/**
 * ErrorBoundary component sends enriched errors to RUM.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, prevScope: props.scope };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error };
    };
    ErrorBoundary.getDerivedStateFromProps = function (props, state) {
        if (state.prevScope !== props.scope) {
            return {
                hasError: false,
                error: undefined,
                prevScope: props.scope,
            };
        }
        return state;
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        var RumGlobal = getGlobalObject().DD_RUM;
        if (RumGlobal) {
            RumGlobal.addError(error, {
                scope: this.props.scope,
            }, 'source');
        }
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, error = _a.error;
        var fallback = this.props.fallback;
        if (!hasError || !error) {
            return this.props.children;
        }
        if (isValidElement(fallback) || typeof fallback === 'string') {
            return fallback;
        }
        else if (typeof fallback === 'function') {
            return fallback(error);
        }
        return null;
    };
    ErrorBoundary.defaultProps = {
        scope: 'error-boundary',
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map